module.exports = __webpack_public_path__ + "assets/icon-powerSource-power12V.4facde7c.svg";